import React from 'react';
import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { PaymentInfoForm } from '@/modules/partner/model/form';
import { TextField } from '@src-common/view/adapters/reactHookForm/TextField';

type Props = {
  control: Control<PaymentInfoForm>;
};

const FrPaymentInfo: React.FC<Props> = ({ control }) => {
  const intl = useIntl();

  return (
    <>
      <TextField
        name="swift"
        title={intl.formatMessage({
          defaultMessage: 'ACCOUNT NUMBER',
          id: 'n8n0/+',
          description: 'Account number field title',
        })}
        placeholder={intl.formatMessage({
          defaultMessage: '0500013M026',
          id: '6EYCB/',
          description: 'FR Account number (swift/bic) field placeholder',
        })}
        control={control}
      />
      <TextField
        name="iban"
        title={intl.formatMessage({
          defaultMessage: 'IBAN',
          id: '3M6gjP',
          description: 'IBAN field title',
        })}
        placeholder={intl.formatMessage({
          defaultMessage: 'FR1420041010050500013M02606',
          id: '+uglhw',
          description: 'FR iban field placeholder',
        })}
        control={control}
      />
    </>
  );
};

export { FrPaymentInfo };
